import React from "react";
import {Link} from "react-router-dom";

const getPagesList = (pageNumber, itemsPerPage, numItems) => {
    let pages = []
    let last = Math.trunc((numItems-1)/itemsPerPage)+1
    let i
    for(i=1; i<= last; i++) {
        let className=""
        if (i === pageNumber) {
            className = "disabled"
        }
        pages.push({
            id: i,
            class: className,
        })
    }
    return pages
}

const Pagination = ({pageNumber, itemsPerPage, numItems, linkBase}) => {
    if ( numItems === 0 ) {
        return (<></>)
    }

    let start = pageNumber - 3
    if (start < 0) {
        start = 0
    }
    let pages = getPagesList(pageNumber, itemsPerPage, numItems)

    const first = <li key={'first'} className={`page-item ${pages[0].class}`}><Link to={`${linkBase}${pages[0].id}`} className="page-link">First</Link></li>
    const last = <li key={'last'} className={`page-item ${pages[pages.length-1].class}`}><Link to={`${linkBase}${pages[pages.length-1].id}`} className="page-link">Last</Link></li>
    const pageItems = pages.slice(start, start+5).map((item) => {
        return <li key={item.id} className={`page-item ${item.class}`}><Link to={`${linkBase}${item.id}`} className="page-link">{item.id}</Link></li>
    })


    return (
        <nav>
            <ul className="pagination">
                {first}
                {pageItems}
                {last}
            </ul>
        </nav>
    )
}

export default Pagination
